(function () {
  'use strict';
  var LW = window.LW || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var body = document.body;
  var scrim = document.querySelector('.lw-scrim');
  var openEl = null;
  var lastFocus = null;

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = LW.moneyFormat || '{{amount}}';
    var v = (cents / 100);
    function fix(n, d, ts, ds) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fix(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(v, 0, '.', ',');
        default: return fix(v, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- panels (menu, bag, size chart) ---------- */
  var panels = { menu: '#lw-menu', cart: '#lw-cart', sizechart: '#lw-sizechart' };
  function open(name) {
    var el = document.querySelector(panels[name]);
    if (!el) return;
    close();
    lastFocus = document.activeElement;
    if (name === 'sizechart') {
      var src = document.querySelector('[data-lw-sizechart-src]');
      var target = el.querySelector('[data-lw-sizechart-body]');
      if (src && target) {
        target.innerHTML = '';
        target.appendChild(src.content.cloneNode(true));
        target.querySelectorAll('table').forEach(function (t) {
          if (t.parentNode.classList.contains('lw-table-wrap')) return;
          var w = document.createElement('div'); w.className = 'lw-table-wrap';
          t.parentNode.insertBefore(w, t); w.appendChild(t);
        });
      }
    } else if (scrim) {
      scrim.hidden = false;
    }
    el.hidden = false;
    openEl = el;
    body.classList.add('lw-lock');
    document.querySelectorAll('[data-lw-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = el.querySelector('button, a, input');
    if (f) f.focus({ preventScroll: true });
    if (name === 'cart') renderCart();
  }
  function close() {
    if (!openEl) return;
    openEl.hidden = true;
    if (scrim) scrim.hidden = true;
    body.classList.remove('lw-lock');
    document.querySelectorAll('[data-lw-open][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lw-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-lw-open')); return; }
    if (e.target.closest('[data-lw-close]')) { close(); return; }
    if (e.target.classList && e.target.classList.contains('lw-modal')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- cart ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-lw-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-on', n > 0); });
    document.querySelectorAll('[data-lw-count-text]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function renderCart(cart) {
    var bodyEl = document.querySelector('[data-lw-cart-body]');
    var foot = document.querySelector('[data-lw-cart-foot]');
    if (!bodyEl) return Promise.resolve();
    var p = cart ? Promise.resolve(cart) : getCart();
    return p.then(function (c) {
      setCount(c.item_count);
      if (!c.item_count) {
        bodyEl.innerHTML = '<p class="lw-empty">Your bag is empty.</p>';
        foot.hidden = true;
        return c;
      }
      bodyEl.innerHTML = c.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="">' : '';
        var opts = (it.variant_title && it.variant_title !== 'Default Title') ? esc(it.variant_title) : '';
        return '<div class="lw-line" data-key="' + esc(it.key) + '">' +
          '<a class="lw-line-img" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div><a class="lw-line-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="lw-line-meta">' + opts + '</div>' : '') +
          '<div class="lw-qty"><button type="button" data-lw-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-lw-qty="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="lw-line-remove" data-lw-remove>Remove</button></div>' +
          '<div class="lw-line-price">' + money(it.final_line_price) + '</div></div>';
      }).join('');
      var sub = document.querySelector('[data-lw-subtotal]');
      if (sub) sub.textContent = money(c.total_price);
      foot.hidden = false;
      return c;
    }).catch(function () {
      bodyEl.innerHTML = '<p class="lw-empty">Could not load your bag. Refresh the page and try again.</p>';
    });
  }
  function changeLine(key, qty) {
    var bodyEl = document.querySelector('[data-lw-cart-body]');
    bodyEl.classList.add('is-busy');
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(renderCart)
      .catch(function (err) { alertLine(err); return renderCart(); })
      .finally(function () { bodyEl.classList.remove('is-busy'); });
  }
  function alertLine(err) {
    var bodyEl = document.querySelector('[data-lw-cart-body]');
    var msg = (err && (err.description || err.message)) || 'That change could not be made.';
    var p = document.createElement('p'); p.className = 'lw-cart-note'; p.textContent = msg;
    bodyEl.prepend(p);
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.lw-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var q = e.target.closest('[data-lw-qty]');
    if (q) {
      var cur = parseInt(line.querySelector('.lw-qty span').textContent, 10) || 0;
      changeLine(key, Math.max(0, cur + parseInt(q.getAttribute('data-lw-qty'), 10)));
    } else if (e.target.closest('[data-lw-remove]')) {
      changeLine(key, 0);
    }
  });

  function addToCart(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- product page ---------- */
  var pdp = document.querySelector('[data-lw-pdp]');
  if (pdp) {
    var slides = Array.prototype.slice.call(pdp.querySelectorAll('[data-lw-slide]'));
    var dots = Array.prototype.slice.call(pdp.querySelectorAll('.lw-dots span'));
    var idx = 0;
    function show(n) {
      if (slides.length < 2) return;
      slides[idx].classList.remove('is-active'); if (dots[idx]) dots[idx].classList.remove('is-active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active'); if (dots[idx]) dots[idx].classList.add('is-active');
    }
    var prev = pdp.querySelector('[data-lw-prev]'), next = pdp.querySelector('[data-lw-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var sx = null, stage = pdp.querySelector('[data-lw-slides]');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      });
    }

    var form = pdp.querySelector('[data-lw-form]');
    var note = pdp.querySelector('[data-lw-note]');
    var sizes = pdp.querySelector('.lw-sizes');
    var addBtn = pdp.querySelector('[data-lw-add]');
    var addLabel = pdp.querySelector('[data-lw-add-label]');
    var selEl = pdp.querySelector('[data-lw-sel]');
    var idInput = form ? form.querySelector('[data-lw-variant-id]') : null;
    var priceEl = pdp.querySelector('[data-lw-price]');
    var noteTimer;

    function say(msg, ok, withBag) {
      clearTimeout(noteTimer);
      note.classList.toggle('is-ok', !!ok);
      note.innerHTML = esc(msg) + (withBag ? ' · <button type="button" data-lw-open="cart">View bag</button>' : '');
      if (ok) noteTimer = setTimeout(function () { note.textContent = ''; note.classList.remove('is-ok'); }, 4000);
    }

    if (sizes) {
      sizes.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lw-size]');
        if (!b || b.disabled) return;
        sizes.querySelectorAll('[data-lw-size]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        idInput.value = b.dataset.id;
        if (selEl) selEl.textContent = '— ' + b.dataset.label;
        if (priceEl && b.dataset.price) priceEl.innerHTML = b.dataset.price;
        addBtn.setAttribute('aria-disabled', 'false');
        addLabel.textContent = 'Add to bag — ' + (b.dataset.price || '');
        note.textContent = '';
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.getAttribute('aria-disabled') === 'true' || !idInput.value) {
          if (sizes) { say('Pick a size first'); var f = sizes.querySelector('.lw-size:not(:disabled)'); if (f) f.focus(); }
          return;
        }
        addBtn.classList.add('is-busy');
        addToCart(idInput.value)
          .then(function () { return getCart(); })
          .then(function (c) { setCount(c.item_count); say('Added to bag', true, true); open('cart'); })
          .catch(function (err) { say((err && err.description) || 'Could not add to bag. Try again.'); })
          .finally(function () { addBtn.classList.remove('is-busy'); });
      });
    }
  }

  /* ---------- sign-up box ---------- */
  var signup = document.querySelector('[data-lw-signup]');
  if (signup) {
    var KEY = 'lw-signup-dismissed';
    var dismissed = false;
    try { dismissed = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dismissed && !/customer_posted=true|contact_posted/.test(location.search)) signup.hidden = true;
    var x = signup.querySelector('[data-lw-signup-close]');
    if (x) x.addEventListener('click', function () {
      signup.hidden = true;
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  /* ---------- keep count fresh (back/forward cache, other tabs) ---------- */
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(function (c) { setCount(c.item_count); }); });
})();
